"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ProductsModel = /** @class */ (function () {
    function ProductsModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/crm/products",
            UPDATE: APPURL + "/api/v1/crm/products",
            CREATE: APPURL + "/api/v1/crm/products",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.show = this.show.bind(this);
        this.get = this.get.bind(this);
        this.update = this.update.bind(this);
        this.toggleData = this.toggleData.bind(this);
        this.create = this.create.bind(this);
    }
    ProductsModel.prototype.extract = function (result) {
        return result.data;
    };
    ProductsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ProductsModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ProductsModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        var url = this.URLS.FETCH;
        if (data !== null) {
            url = this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data);
        }
        return this.$http.get(url).then(this.cacheResults);
    };
    ProductsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ProductsModel.prototype.toggleData = function (product) {
        return this.$http
            .patch(this.URLS.FETCH + "/toggle/" + product.id, product)
            .then(this.cacheResults);
    };
    ProductsModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ProductsModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    return ProductsModel;
}());
ProductsModel.$inject = ["$http", "APPURL"];
exports.default = ProductsModel;
